module.exports = __webpack_public_path__ + "static/media/lamborghini-go-drive.08dc50cf.jpg";